import { ChangeEvent, createElement, useCallback, useRef } from "react";

export interface FileInputOptions {
    onSelect?(file: File);
}

export const useFileInput = (options: FileInputOptions = {}) => {
    const inputFileRef = useRef<HTMLInputElement>();

    const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        if (!event?.target) {
            return;
        }

        const file = (event.target.files || [])[0];

        options?.onSelect?.(file);

        event.target.value = null;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options?.onSelect, inputFileRef?.current]);

    const openFileInputDialog = useCallback(() => {
        if (typeof inputFileRef?.current?.click !== "function") {
            return;
        }

        inputFileRef.current.click();
    }, []);

    return {
        openFileInputDialog,
        fileInputElement: createElement("input", {
            key: "inputfile",
            type: "file",
            style: { display: "none" },
            ref: inputFileRef,
            onChange: handleChange,
        }),
    };
};
